<template>
  <!-- Logo temporarily hidden -->
  <router-link
    :to="$route.meta.sidebar !== 'main' ? `/${currentWebsite.websiteId}/realtime/` : '/'"
    class="shrink-0"
    v-if="false"
  >
    <img
      v-if="!isMinimized"
      src="/exporio-logo-light.svg"
      class="ml-2 h-[30px] opacity-100 hover:opacity-90"
      alt="exporio-logo"
    />
    <img
      v-else
      src="/exporio-mini-logo-light.svg"
      class="h-[30px] opacity-100 hover:opacity-90"
      alt="exporio-logo"
    />
  </router-link>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        currentWebsite: {
            type: Object,
            required: true
        },
        isMinimized: {
            type: Boolean,
            required: true
        }
    }
})
</script>
